@use '../../styling/colors.scss' as *;

.CollapseButton {
  background: $color-white;
  border-radius: 50%;
  border: 3px solid $color-secondary-purple;
  color: $color-secondary-purple;
  cursor: pointer;
  height: 33px;
  padding: 0;
  width: 33px;

  &:focus {
    outline: none;
  }

  svg {
    vertical-align: text-bottom;
    // "Center" it
    margin-left: -2px;
  }
}
